// extracted by mini-css-extract-plugin
module.exports = {"link":"_2xv4R1Miw60GLhM_IwyPFQ"};